import { useCallback } from "react";
import { useAlert } from "./Alert";
import { useAuthenticatedFetch } from "./Authenticator";
import { toast } from "react-toastify";

export const useProjectRemove = () => {
  const fetch = useAuthenticatedFetch();
  const { confirm } = useAlert();
  const remove = useCallback(
    async (id: number, callback?: () => void) => {
      const result = await confirm({
        title: "Delete this project?",
        message:
          "All associated script files will become project-less. This action cannot be undone.",
      });
      if (result === "accept") {
        await fetch(`/me/project/${id}`, {
          method: "DELETE",
        });
        toast.success("Deleted project");
        if (callback) callback();
      }
    },
    [fetch, confirm]
  );
  return remove;
};
